const kitCatalog = [
  {
    id: '2402IDO02-ISC',
    desc: 'Airfield Response Support System (oversized equipment)',
    manu: 'KIT',
    price: '$1,724,383.05',
  },
  {
    id: '2402IDO02-JCP',
    desc: 'Airfield Response Support System (standard equipment)',
    manu: 'KIT',
    price: '$39,291.04',
  },
  {
    id: '2402IDO02-TC',
    desc: 'Airfield Response Support System in-country training and commissioningG',
    manu: 'KIT',
    price: '$74,196.67',
  },
  {
    id: '2402PLW02-JCP',
    desc: 'Airfield HAZMAT Support System (standard equipment)',
    manu: 'KIT',
    price: '$10,576.20',
  },
  {
    id: '2402PNG02-JCP',
    desc: 'Airfield Handling Support System (standard equipment)',
    manu: 'KIT',
    price: '$36,741.60',
  },
  {
    id: '2402FSM02-ISC',
    desc: 'Airfield Handling Support System (oversized equipment)',
    manu: 'KIT',
    price: '$3,419,291.78',
  },
  {
    id: '2402FSM02-JCP',
    desc: 'Airfield Protective & Containment System (standard equipment)',
    manu: 'KIT',
    price: '$1,449,076.42',
  },
  {
    id: '2402FSM02-TC',
    desc: 'Airfield Protective & Containment System in-country training and commissioning',
    manu: 'KIT',
    price: '$74,196.67',
  },
  {
    id: '2402CPV02-ISC',
    desc: 'Airfield Vehicle Support System (oversized equipment)',
    manu: 'KIT',
    price: '$910,605.91',
  },
  {
    id: '2402PHL02-JCP',
    desc: 'Airfield Support System (standard equipment)',
    manu: 'KIT',
    price: '$277,688.45',
  },
  {
    id: '2402PHL02-ISC',
    desc: 'Airfield Support System (standard equipment)',
    manu: 'KIT',
    price: '$1,124,444.44',
  },
  {
    id: '2402PHL02-TC',
    desc: 'Airfield Support System in-country training and commissioning',
    manu: 'KIT',
    price: '$74,196.67',
  },
];

const tableBody = document.querySelector('.table__kit tbody');

kitCatalog.forEach(item => {
  const row = document.createElement('tr');
  // Create cells for ID, Description, and Price
  const idCell = document.createElement('td');
  idCell.textContent = item.id;

  const descCell = document.createElement('td');
  descCell.textContent = item.desc;

  const manuCell = document.createElement('td');
  manuCell.textContent = item.manu;

  const priceCell = document.createElement('td');
  priceCell.textContent = item.price;

  // Append the cells to the row
  row.appendChild(idCell);
  row.appendChild(descCell);
  row.appendChild(manuCell);
  row.appendChild(priceCell);

  // Append the row to the table body
  tableBody.appendChild(row);
});
